module.exports = __webpack_public_path__ + "static/media/ata-logo.0fd7b797.svg";